export default function getDesa(filterText) {
  filterText = filterText ? filterText.replace(' ','_') : '';
  if(filterText.length>=3){
let dataDesa=[];
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', `https://api.dekatan.com/publik/desa/${filterText}`);
    xhr.send();

    xhr.onload = () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        dataDesa = JSON.parse(xhr.response); 
        resolve(dataDesa.list) 
      } else {
        reject()
      }
    };
  });
}else {return new Promise((resolve, reject) => {
    resolve([]) 
});
}
}